<template>
  <v-app id="portal">
    <v-content class="px-3">
      <titulo-responsivo
        :titulo="locale[local].screen.oportunidades.string001"
      />
      <v-divider />

      <v-container fluid grid-list-md class="pl-1 pr-1">
        <v-layout row wrap align-center justify-center>
          <v-flex xs12 v-for="(vaga, vagakey) in vagas" :key="vagakey">
            <v-card style="border-radius: 10px" class="pa-2 elevation-5">
              <v-card-text class="text-left">
                <v-layout
                  row
                  wrap
                  justify-space-between
                  align-center
                  class="hidden-sm-and-down"
                >
                  <v-flex>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <h2>{{ vaga.descricao }}</h2>
                      </v-flex>
                      <v-flex xs6 lg3>
                        <h4>{{ vaga.cidade }}</h4>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <div style="text-align: center">
                    <v-btn color="primary" @click="showDialog(vaga)">
                      <v-icon left>mdi-account-details</v-icon>Detalhar vaga
                    </v-btn>
                  </div>
                </v-layout>
                <v-layout
                  row
                  wrap
                  justify-space-between
                  align-center
                  class="hidden-md-and-up"
                >
                  <v-flex>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <h2>{{ vaga.descricao }}</h2>
                      </v-flex>
                      <v-flex xs6 lg3>
                        <h4>{{ vaga.cidade }}</h4>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex style="text-align: center">
                    <v-btn block color="primary" @click="showDialog(vaga)">
                      <v-icon left>mdi-account-details</v-icon>Detalhar vaga
                    </v-btn>
                    <p>
                      {{
                        moment(vaga.dtRequisicao, "yyyy-MM-dd").format(
                          "DD/MM/YYYY"
                        )
                      }}
                    </p>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <v-dialog v-model="dialog" width="500" persistent>
      <v-card class="text-left">
        <v-card-title class="headline grey lighten-2" primary-title>
          Detalhes
          <v-spacer></v-spacer>
          <v-progress-circular
            v-if="showProgress"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-card-title>

        <v-card-text class="pt-5">
          <p>Cargo: {{ vaga.cargo }}</p>
          <p>Setor: {{ vaga.setor }}</p>
          <p>Cidade: {{ vaga.cidade }}</p>
          <p>Vagas: {{ vaga.numVagas }}</p>
          <p>Requisitos: {{ vaga.Requisitos }}</p>
        </v-card-text>
        <template v-if="vaga.beneficios != ''">
          <v-divider></v-divider>
          <v-card-title v-if="vaga.beneficios != ''">Benefícios</v-card-title>
          <v-card-text class="text-left pa-0 pl-5 pr-3">
            <p style="white-space: pre">{{ vaga.beneficios }}</p>
          </v-card-text>
        </template>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            color="primary"
            @click="dialog = false"
            :disabled="showProgress"
            >Fechar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="candidatar(vaga)"
            :disabled="showProgress"
            >Candidatar-se</v-btn
          >
        </v-card-actions>
      </v-card>

      <v-card-text>
        <v-overlay v-model="carregando">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card-text>

    </v-dialog>
  </v-app>
</template>

<script>
import Service from "../components/api/Service";
import moment from "moment";
import { alert } from "cids-cgi/lib/util";

export default {
  data: () => ({
    snackbar: false,
    vagas: [],
    carregando: false,
    dialog: false,
    vaga: {
      Requisitos: null,
      cargo: null,
      cidade: null,
      codRequisicao: null,
      descricao: null,
      dtRequisicao: null,
      numVagas: null,
      setor: null,
    },
    showProgress: false,
  }),
  async mounted() {},
  created() {
    moment.locale("pt-br");
    this.buscarOportunidades();
  },
  methods: {
    async buscarOportunidades() {
      this.carregando = true;

      try {
        const service = new Service();
        this.vagas = await service.buscarOportunidadesInternas();

      } catch (e) {
      } finally {
        this.carregando = false;
      }
    },
    showDialog(vaga) {
      this.dialog = true;
      this.vaga = vaga;
    },
    async candidatar(vaga) {
      this.carregando = true;
      try {
        const service = new Service();
        const retorno = await service.candidatarVaga(vaga);
  
        if (retorno[0].estatus === "Erro"){
          alert.show({ message: retorno[0].msgErro.split("2 - ")[1], color: 'red'  });
        } else  {
          alert.show({ message: retorno[0].msgErro.split("1 - ")[1], color: 'green'  });
        }

      } catch (e) {
      } finally {
        this.carregando = false;
      }
    },
  },
};
</script>
